<template>
  <div class="giveClass">
    <div class="giveClass_top">
      <div class="title_box">
        <div class="ico_tuwen">
          <img
            src="https://fview.5kjs.com/activity/21sign/image/pc/details.png"
            alt=""
          />
        </div>
        <div class="day">
          <div>赠课{{ num }}</div>
          <!-- <div class="endTime">请先领取</div> -->
          <div class="endTime" v-if="isApply">
            {{
              item.is_receive == 0
                ? "请先领取"
                : `观看进度：${item.planned_speed==null?'0':item.planned_speed}%`
            }}
          </div>
        </div>
        <div class="title">
          {{ item.free_name }}
          <span class="isTime" v-if="isApply && item.is_receive != 0">
            有效期：{{ item.start_date }}~{{ item.end_date }}
          </span>
        </div>
        <!-- <div class="isTime">有效期：2099-99-99~2099-99-99</div> -->
      </div>
      <!-- 判断当前是领取还是观看 -->
      <div>
        <div
          class="btn"
          :class="[isApply ? '' : 'noApply']"
          v-if="item.is_receive == 0"
          @click="setCampFree"
        >
          领取
        </div>
        <div
          class="btn"
          :class="[isLook ? '' : 'noLook']"
          style="background-color: rgba(254, 138, 138, 100)"
          v-else
          @click="jumpLook(isLook)"
        >
          观看
        </div>
      </div>
    </div>
    <!-- 赠课领取成功弹框 -->
    <div class="messageModel" v-if="classMassage">
      <!-- 领取成功内容和领取失败内容判断 -->
      <i
        class="iconfont"
        :class="[givClassStatus ? 'icon-duigou' : 'icon-gantanhao']"
      ></i>
      <div class="messageModel_text">
        {{ givClassStatus ? "赠课领取成功" : "赠课领取失败" }}
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    // 接收传入的item信息
    item: {
      type: Object,
    },
    // 接收传入的数量排序值
    num: {
      type: Number,
    },
    // 是否购买
    isApply: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      //课程领取成功的massage弹框
      classMassage: false,
      // 课程领取成功的判断
      givClassStatus: true,
    };
  },
  methods: {
    // 领课弹框功能
    giveMassageFn() {
      this.classMassage = true;
      let that = this;
      setTimeout(() => {
        that.classMassage = false;
        that.givClassStatus = true; //每次弹框完之后初始化弹框状态未领取成功的状态
      }, 1500);
    },
    // 课程领取操作
    setCampFree() {
      console.log(this.item.camp_id);
      if (!this.isApply) {
        this.$alert("报名之后才能领取噢~~~", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }

      let fromdata = new FormData();
      fromdata.append("lesson_id", this.item.pattern_id);
      this.$axios
        .post(
          `/setCampFree?camp_id=${this.item.camp_id}&token=${this.token}&agency_id=${this.agency_id}`,
          fromdata
        )
        .then((doc) => {
          console.log(doc);
          if (doc != null) {
            this.givClassStatus = false;
          }
          this.giveMassageFn();
          this.$emit("freeUpdate");
        })
        .catch((err) => {
          console.log(err);
          this.givClassStatus = false;
          this.giveMassageFn();
          this.$emit("freeUpdate");
        });
    },
    // 观看跳转功能
    jumpLook() {
      if (this.isLook) {
        window.location.href = this.item.link;
      } else {
        this.$alert("课程还未开放", "提示", {
          confirmButtonText: "确定",
        });
      }
    },
  },
  computed: {
    ...mapState(["token", "agency_id"]),
    // 当前课程是否可观看0不可看1可看
    isLook() {
      var status = this.item.is_watch == 0 ? false : true;
      return status;
    },
  },
};
</script>
<style lang="less" scoped>
.giveClass {
  margin-bottom: 0.9rem;
  border-radius: 0.125rem;
  .giveClass_top {
    padding: 0.3125rem 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 3.375rem;
    background: #f5f7fa;
    .title_box {
      padding: 0.3125rem 0;
      margin-left: 1.1875rem;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      .ico_tuwen {
        width: 1.3125rem;
        height: 1.3125rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .day {
        margin: 0 1.25rem 0 0.5rem;
        color: #686868;
        font-size: 1rem;
        font-weight: 700;
        .endTime {
          font-size: 0.7rem;
          font-weight: 400;
          color: #999;
        }
      }
      .title {
        flex: 1;
        font-size: 1rem;
        font-family: \MicrosoftYaHei;
        font-weight: 400;
        color: #686868;
      }
      .isTime {
        display: inline-block;
        margin-left: 0.625rem;
        font-size: 0.7rem;
        font-weight: 400;
        color: #999;
        line-height: 1rem;
      }
    }
  }
  .btn {
    cursor: pointer;
    flex-shrink: 0;
    margin-right: 0.6875rem;
    width: 3.5625rem;
    height: 1.625rem;
    border-radius: 0.8rem;
    background-color: rgba(24, 188, 156, 100);
    color: rgba(255, 255, 255, 100);
    font-size: 0.75rem;
    text-align: center;
    font-family: Microsoft Yahei;
    line-height: 1.625rem;
  }
  // 不能观看状态
  .noLook {
    background-color: #999 !important;
  }
  // 未报名不能领取状态
  .noApply {
    background-color: #999 !important;
  }
  // 赠课领取成功弹框
  .messageModel {
    z-index: 99;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, 50%);
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;
    padding: 1.125rem 2.375rem;
    background-color: rgba(30, 30, 30, 0.5);
    color: #fff;
    border-radius: 0.5rem;
    .icon-duigou::before,
    .icon-gantanhao::before {
      font-size: 3.125rem;
    }
    .messageModel_text {
      margin-left: 0.625rem;
      line-height: 3.125rem;
    }
  }
}
</style>